import { render, staticRenderFns } from "./subjectServiceCharge.vue?vue&type=template&id=382a807a&"
import script from "./subjectServiceCharge.vue?vue&type=script&lang=js&"
export * from "./subjectServiceCharge.vue?vue&type=script&lang=js&"
import style0 from "./subjectServiceCharge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports